import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, Collapse, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Countdown, { CountdownRenderProps } from 'react-countdown'
import moment from 'moment/moment'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import * as ls from 'local-storage'
import { UniversalTypeCheckList } from './check-list-type'
import { ConfirmListModal, OutListModal } from './modals-check-list'
import { useReduxSelector } from '../../../hooks'
import {
  startCheckList,
  saveCheckList,
  finishCheckList,
  startCheckListV2,
  saveCheckListV2,
  finishCheckListV2,
} from '../../../api'
import { propsAction } from '../../../store/props'
import { modalsAction } from '../../../store/modals'
import { Loader } from '../../../components'

const Renderer: React.FC<CountdownRenderProps> = ({ hours, minutes }) => {
  return (
    <>
      <span>{hours}&nbsp;ч.&nbsp;</span>&nbsp;
      <span>{minutes}&nbsp;мин.&nbsp;</span>
    </>
  )
}

export const Timer: React.FC<{ timeEnd: number }> = ({ timeEnd = 0 }) => {
  return <Countdown date={timeEnd} renderer={(props) => <Renderer {...props} />} />
}

export const CheckListPage: React.FC<{ userData: any; updateInfo(): void; img: any }> = ({
  userData = [],
  updateInfo,
  img = [],
}): JSX.Element => {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const now = new Date()
  const start = moment(now).valueOf() + 43200000

  const {
    checklist_all: { checklist: dataCheckList, employee: dataEmployee, loaded: loadedCheckList },
  } = useReduxSelector((state) => state.props)

  const { data: constants } = useReduxSelector((state) => state.constants)
  const { NOW = 0 } = constants || {}

  const [formProps, setFormProps] = useState<any>({
    processed: false,
    snackbar: {
      message: undefined,
      onClose: () => setFormProps({ ...formProps, snackbar: { ...formProps.snackbar, message: undefined } }),
    },
  })

  const [confirmModalList, setConfirmModalList] = useState<boolean>(false)
  const [closeModalList, setCloseModalList] = useState<boolean>(false)

  const onChangeEmployeeStatus = () => {
    dispatch(
      modalsAction.alert({
        actionButtonText: 'Продолжить',
        onAction: () => {
          startCheckList({ requestId: dataEmployee.id })
            .then((res) => {
              if (res.status === 1) {
                const checklist_all = {
                  loaded: false,
                  employee: {
                    ...dataEmployee,
                    checklist: {
                      ...res.data.checklist,
                      moderUser: { ...userData },
                      status: 'ACTIVE',
                    },
                  },
                  checklist: { ...res.data.checklist },
                }
                dispatch(propsAction.setProps({ checklist_all }))
              } else {
                dispatch(
                  modalsAction.alert({
                    message: { error: [`${res.message}`] },
                    onClose: () => {},
                  })
                )
              }
            })
            .catch(() => {
              dispatch(
                modalsAction.alert({
                  message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
                  onClose: () => {},
                })
              )
            })
        },
        message: {
          info: [
            '<span>Время работы с Чек-листом ограничено - максимум 12 часов с момента начала его заполнения.</span>' +
              '<br /><span>У вас есть менее 12 часов на все Чек-листы до времени окончания этапа. После этого ' +
              'времени Чек-лист будет заблокирован, продолжить работу с ним будет нельзя.</span>',
          ],
        },
        onClose: () => {},
      })
    )
  }

  const handleChangeList = (data: any) => {
    setFormProps({ ...formProps, processed: true })

    saveCheckList({
      requestId: dataEmployee.id,
      answers: [
        {
          checklistAnswers: [
            {
              variantVarsId: data.varsId,
              variantsId: data.variantsId,
            },
          ],
          checklistId: data.quizId,
        },
      ],
    })
      .then((res) => {
        if (res.status === 1) {
          const checklist_all = {
            loaded: false,
            employee: { ...dataEmployee },
            checklist: { ...res.data.checklist },
          }
          dispatch(propsAction.setProps({ checklist_all }))
          setFormProps({ ...formProps, processed: false })
        } else {
          dispatch(
            modalsAction.alert({
              message: { error: [`${res.message}`] },
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
            onClose: () => {},
          })
        )
      })
  }

  const onFinishCheckList = () => {
    finishCheckList({ requestId: dataEmployee.id })
      .then((res) => {
        if (res.status === 1) {
          const checklist_all = {
            loaded: false,
            employee: undefined,
            checklist: undefined,
          }
          updateInfo()
          dispatch(propsAction.setProps({ checklist_all }))
          setConfirmModalList(false)
          ls.remove('checklist')
          navigate('../lk')
        } else {
          dispatch(
            modalsAction.alert({
              message: { error: [`${res.message}`] },
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
            onClose: () => {},
          })
        )
      })
  }

  const onConfirmOutCheckList = () => {
    const checklist_all = {
      loaded: false,
      employee: undefined,
      checklist: undefined,
    }
    updateInfo()
    dispatch(propsAction.setProps({ checklist_all }))
    setCloseModalList(false)
    ls.remove('checklist')
    navigate('../lk')
  }

  const onCloseOutCheckList = (cross: boolean) => {
    if (cross) {
      setConfirmModalList(false)
    } else {
      const checklist_all = {
        loaded: false,
        employee: undefined,
        checklist: undefined,
      }
      updateInfo()
      dispatch(propsAction.setProps({ checklist_all }))
      setConfirmModalList(false)
      ls.remove('checklist')
      navigate('../lk')
    }
  }

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <>
      {dataCheckList && dataEmployee && !loadedCheckList ? (
        <>
          <OutListModal
            data={dataEmployee}
            show={closeModalList}
            onConfirm={onConfirmOutCheckList}
            onClose={() => setCloseModalList(false)}
          />

          <ConfirmListModal
            data={dataEmployee}
            show={confirmModalList}
            onConfirm={onFinishCheckList}
            onClose={onCloseOutCheckList}
          />

          <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" spacing={1}>
            <Grid item>
              <Box className={classes.title}>Чек-лист</Box>
            </Grid>
            <Grid item>
              {dataEmployee.checklist?.status === 'ACTIVE' &&
                dataEmployee.checklist?.endDatetime &&
                moment(NOW).isBefore(moment(dataEmployee.checklist?.endDatetime).valueOf()) && (
                  <Box className={classes.timer}>
                    <Timer timeEnd={moment(dataEmployee.checklist?.endDatetime).valueOf()} />
                  </Box>
                )}
            </Grid>
          </Grid>
          <Box className={classes.info}>
            <Box mb={1}>
              <span>Номинация:</span> {dataEmployee?.nomination.name}
            </Box>
            <Box mb={1}>
              <span>Оцениваемый:</span> {dataEmployee?.command.users.length > 1 ? 'Команда «' : null}
              {dataEmployee?.command.users.length > 1 ? (
                dataEmployee?.command.name
              ) : (
                <>
                  {dataEmployee?.command.users[0].lastName} {dataEmployee?.command.users[0].firstName}{' '}
                  {dataEmployee?.command.users[0].middleName}
                </>
              )}
              {dataEmployee?.command.users.length > 1 ? '»' : null}
            </Box>
            {dataEmployee?.checklist && (
              <Box>
                <span>Оценивающий:</span> {dataEmployee?.checklist?.moderUser.shortName}
              </Box>
            )}
          </Box>

          <Box className={classes.dataBox}>
            <Collapse in={dataEmployee.checklist === null}>
              <Box className={classes.btnBox}>
                {dataEmployee.checklist === null && (
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.btn}
                        onClick={onChangeEmployeeStatus}
                      >
                        Начать заполнение Чек-листа
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Box>
            </Collapse>
            <Box mt={4}>
              {dataCheckList && (
                <UniversalTypeCheckList
                  dataCheckList={dataCheckList}
                  dataEmployee={dataEmployee}
                  formProps={formProps}
                  updateInfo={updateInfo}
                  handleChangeList={handleChangeList}
                  disableList={
                    dataEmployee.checklist === null ||
                    dataEmployee.checklist?.status === 'FINISH' ||
                    formProps.processed
                  }
                  onConfirmList={() => setConfirmModalList(true)}
                  onCloseList={() => setCloseModalList(true)}
                  className={classes}
                  img={img}
                />
              )}
            </Box>
          </Box>
        </>
      ) : (
        <Grid container direction="column" justifyContent="center" alignItems="center" style={{ height: '60vh' }}>
          <Grid item>
            <Loader />
          </Grid>
          <Grid item>
            <Box mt={5} className={classes.emplyText}>
              Загрузка данных Чек-листа...
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  title: {
    fontSize: 28,
    fontWeight: 600,
    [down('md')]: {
      fontSize: 25,
    },
    [down('sm')]: {
      fontSize: 22,
    },
  },
  timer: {
    fontSize: 22,
    fontWeight: 600,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 20,
    },
    [down('sm')]: {
      fontSize: 16,
    },
  },
  info: {
    fontWeight: 600,
    fontSize: 20,
    marginTop: 15,
    '& span': {
      color: '#6C6C6C',
    },
    [down('md')]: {
      fontSize: 18,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  dataBox: {},
  contentAccordionDetailsQuiz: {
    borderTop: '2px solid #BABABA',
    padding: '20px 0 0 40px',
    [down('md')]: {
      padding: '20px 3px 0 3.5vw',
    },
    [down('sm')]: {
      padding: '15px 0 0',
    },
  },
  icon: {},
  btn: {
    paddingLeft: '40px!important',
    paddingRight: '40px!important',
    [down('sm')]: {
      paddingLeft: '30px!important',
      paddingRight: '30px!important',
    },
  },
  btnBox: {
    height: 52,
    marginTop: 30,
  },
  emplyText: {
    textAlign: 'center',
    [down('sm')]: {
      fontSize: 17,
    },
  },
  iconCheck: {
    width: 11,
    height: 11,
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: `3px solid ${palette.primary.dark}`,
  },
  check: {
    borderRadius: 50,
    width: 11,
    height: 11,
    backgroundColor: ` ${palette.secondary.main}`,
  },
  numQuiz: {
    width: 30,
    fontWeight: 600,
    fontSize: 17,
    color: palette.text.secondary,
    [down('md')]: {
      fontSize: 15,
      width: 25,
    },
    [down('sm')]: {
      fontSize: 14,
      width: 20,
      position: 'relative',
      bottom: 1,
    },
  },
  subGroup: {
    '& .MuiAccordion-root': {
      boxShadow: 'none!important',
      marginBottom: '-5px!important',
      '& .Mui-expanded': {
        margin: '0px!important',
      },
    },
    '& .MuiAccordionSummary-root': {
      justifyContent: 'flex-start',
      paddingLeft: 0,
    },
    '& .MuiAccordionSummary-content': {
      flexGrow: '0!important',
      paddingRight: 15,
      fontSize: 18,
      fontWeight: 700,
      color: '#6C6C6C',
      margin: '0px!important',
      [down('md')]: {
        fontSize: 17,
      },
      [down('sm')]: {
        fontSize: 15.5,
      },
    },
    '& .MuiAccordionDetails-root': {
      paddingLeft: 0,
      paddingRight: 3,
      paddingBottom: 0,
    },
  },
  subGroupAccordionDetailsBox: {
    padding: '0 0 0 30px',
    marginTop: -18,
    [down('md')]: {
      padding: '20px 0 0 3.5vw',
    },
    [down('sm')]: {
      padding: '15px 0 0 10px',
    },
  },
  btnVariable: {
    padding: '12px 40px!important',
    minHeight: '30px!important',
    fontSize: '16px!important',
  },
  universal: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiFormLabel-root': {
      fontWeight: 500,
      fontSize: 16,
      '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, .4)!important',
      },
      [down('md')]: {
        fontSize: 15,
      },
      [down('sm')]: {
        fontSize: 14,
      },
    },
    '& .MuiFormControlLabel-root .MuiTypography-root': {
      fontWeight: 500,
      fontSize: '16px!important',
      '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, .4)!important',
      },
      [down('md')]: {
        fontSize: '15px!important',
      },
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
  btnConfirm: {
    minWidth: '480px!important',
    [down('md')]: {
      fontSize: '17px!important',
      minWidth: '440px!important',
    },
    [down('sm')]: {
      fontSize: '15px!important',
      maxWidth: '370px!important',
      minWidth: '300px!important',
    },
  },
  btnReject: {
    minWidth: '480px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '17px!important',
      minWidth: '440px!important',
    },
    [down('sm')]: {
      maxWidth: '370px!important',
      width: '100%!important',
      fontSize: '15px!important',
      minWidth: '300px!important',
    },
  },
  iconCheckVariable: {
    width: 11,
    height: 11,
    display: 'flex',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: `3px solid ${palette.primary.dark}`,
  },
  checkVariable: {
    borderRadius: 4,
    width: 11,
    height: 11,
    backgroundColor: ` ${palette.secondary.main}`,
  },
  checkVariableDisabled: {
    borderRadius: 4,
    width: 11,
    height: 11,
    backgroundColor: '#6C6C6C',
  },
  iconTop: {
    width: 80,
    height: 80,
    [down('md')]: {
      width: 70,
      height: 70,
    },
  },
  labelLevel2: {
    '& .MuiFormLabel-root': {
      fontWeight: 500,
      fontSize: '16px!important',
      color: `${palette.secondary.main}!important`,
      '&.Mui-disabled': {
        color: 'rgba(226, 18, 34, .6)!important',
      },
      [down('md')]: {
        fontSize: '15px!important',
      },
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
  labelLevel3: {
    '& .MuiFormLabel-root': {
      fontWeight: 700,
      fontSize: '16px!important',
      color: `${palette.secondary.main}!important`,
      '&.Mui-disabled': {
        color: 'rgba(226, 18, 34, .6)!important',
      },
      [down('md')]: {
        fontSize: '15px!important',
      },
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
}))
